// extracted by mini-css-extract-plugin
export default {"card-details-form":"CardDetailsForm_card-details-form__ZJ+XY"};